import { render, staticRenderFns } from "./AddSystemConfig.vue?vue&type=template&id=9c1823fa&scoped=true"
import script from "./AddSystemConfig.vue?vue&type=script&lang=js"
export * from "./AddSystemConfig.vue?vue&type=script&lang=js"
import style0 from "./AddSystemConfig.vue?vue&type=style&index=0&id=9c1823fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1823fa",
  null
  
)

export default component.exports